import React from 'react'
import Svg from './Svg'
export const SvgSortArrow = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M24 5.998L12.001 18 0 5.999" />
  </Svg>
))
SvgSortArrow.isIcon = true
export default SvgSortArrow
